import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

const messages: {
	[key: string]: MessageDescriptor;
} = defineMessages({
	people: {
		id: 'users-and-roles.header.people',
		defaultMessage: 'People',
		description: 'Page header for the People page',
	},
	peopleAndAccess: {
		id: 'users-and-roles.header.people-and-access',
		defaultMessage: 'People and access',
		description: 'Page header for the People page',
	},
	access: {
		id: 'users-and-roles.header.access',
		defaultMessage: 'Access',
		description: 'Page header for the Access page',
	},

	jsdaccess: {
		id: 'users-and-roles.header.jsdaccess',
		defaultMessage: 'Internal access',
		description: 'Page header for the Access page in JSM projects',
	},

	// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
	jsdTMPaccess: {
		id: 'users-and-roles.header.jsdaccess.tmp',
		defaultMessage: 'People and access',
		description: 'Page header for the Access page in JSM team managed projects',
	},
});

export default messages;
